import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router } from "@angular/router";
import { map, Observable } from "rxjs";
import { ComplaintsService } from "../services/CRM/complaints.service";
import { ParameterClass } from "../helpers/helper.service";

// ticket-access.guard.ts
@Injectable({
  providedIn: "root",
})
export class TicketAccessGuard implements CanActivate {
  constructor(private ticketService: ComplaintsService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | boolean {
    const ticketId = route.paramMap.get('ticketId');
    const currentUserId = JSON.parse(localStorage.getItem('user')!).user.id
    
    const params: ParameterClass[] = [
      new ParameterClass('paginate', 'false'),
      new ParameterClass('columns[]', 'user_id'),
      new ParameterClass('operand[]', '='),
      new ParameterClass('column_values[]', currentUserId),
    ];
    return this.ticketService.getComplaints(params).pipe(
      map((complaints: any) => {
        const allowed = complaints.data.map((c: any) => c.id.toString());
        const hasAccess = allowed.includes(ticketId!);
        if (!hasAccess) {
          this.router.navigate(['/error-page/no-access']);
          return false;
        }
        return true;
      })
    );
  }
}
